import * as v3Config from './optionStandard';
import * as v1Config from './optionTemplate1';
import * as v4Config from './optionTemplate4';
import * as brokerConfig from './optionBroker';
import * as oldConfig from './optionOld';

function showPieStyle(result, theme = 'standard', currencySymbol) {
    let templateConfig;
    if (theme == 'template1') {
        templateConfig = v1Config;
    }
    if (theme == 'standard') {
        templateConfig = v3Config;
    }
    if (theme == 'template4') {
        templateConfig = v4Config;
    }
    if (theme == 'broker') {
        templateConfig = brokerConfig;
    }
    if (theme == 'old') {
        templateConfig = oldConfig;
    }

    let titleMap = templateConfig.getTitleMap.call(this);
    var data = [];
    var total = 0;

    let calResult = [];
    for (let key in result) {
        if (result.hasOwnProperty(key) && result[key] > 0 && titleMap[key]) {
            total += +result[key];
        }
    }
    for (let key in result) {
        if (result.hasOwnProperty(key) && result[key] > 0 && titleMap[key]) {
            let name = titleMap[key].name;
            let color = titleMap[key].color;
            let min = Math.round(total * 0.03);
            data.push({
                name: name,
                itemStyle: {
                    color: color
                },
                value: result[key] < min ? min : result[key]
            });
            calResult.push({
                color: color,
                name: name,
                value: result[key],
                key: key
            });
        }
    }
    let option = templateConfig.chartOption.call(this, data, total, currencySymbol);
    return {
        chartOption: option,
        calResult: calResult,
        resNum: total
    };
}

export default showPieStyle;
